webpackJsonp([114276838955818,60335399758886],{

/***/ 187:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(275);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(187);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { style: {} },
	    children
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navigationModule = __webpack_require__(369);
	
	var _navigationModule2 = _interopRequireDefault(_navigationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'nav',
	    { role: 'navigation' },
	    _react2.default.createElement(
	      'ul',
	      { className: _navigationModule2.default.navigation },
	      _react2.default.createElement(
	        'li',
	        { className: _navigationModule2.default.navigationItem },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Home'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        { className: _navigationModule2.default.navigationItem },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog/' },
	          'Blog'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"navigation":"src-components----navigation-module---navigation---_yI7y","navigationItem":"src-components----navigation-module---navigationItem---1plNx"};

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _container = __webpack_require__(266);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _navigation = __webpack_require__(271);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    var header = void 0;
	
	    var rootPath = '/';
	    if (false) {
	      rootPath = __PATH_PREFIX__ + '/';
	    }
	
	    return _react2.default.createElement(
	      _container2.default,
	      null,
	      children()
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-322952652d586b6f647a.js